var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-textarea',_vm._g(_vm._b({attrs:{"value":_vm.localValue,"auto-grow":_vm.autoGrow,"rows":_vm.rows,"row-height":_vm.localRowHeight,"outlined":_vm.outlined,"dense":_vm.dense,"label":_vm.label,"disabled":_vm.disabled},on:{"input":_vm.onInput,"blur":_vm.onBlur}},'v-textarea',_vm.$attrs,false),_vm.localListeners))
}
var staticRenderFns = []

export { render, staticRenderFns }